import { EntityData } from "@/components/TriggerSetup/logic/types/entity-data.type";
import { baseCondition } from "@/components/TriggerSetup/logic/structures/base-condition.structure";
import { TriggerCondition } from "@/components/TriggerSetup/logic/types/types";
import { snakeCase } from "lodash";
import { getTagsByFieldKey } from '@/mixins/TariffsTagsHelper'
import SourceIdentifySetupView from '@/components/TriggerSetup/conditions/SourceIdentify/SourceIdentifySetupView.vue'

const condition: () => EntityData = () => {
  return {
    'setupView': SourceIdentifySetupView,
    'structure': {
      'type': 'SourceIdentify',
      ...baseCondition,
    } as TriggerCondition,
    'titleKey': `trigger_condition_${ snakeCase('SourceIdentify') }`,
    'limited': getTagsByFieldKey('SourceIdentifyCondition'),
  }
}

export default condition
